import React from 'react';
import PropTypes from 'prop-types';
import { AccountComponent } from './AccountComponent';

function AccountListComponent({
  savingPot,
  accountList,
  accountClick,
  content,
}) {
  return (
    <div data-test-id="account-list">
      {accountList.map((account, index) => (
        <AccountComponent
          savingPot={savingPot && account.actionsAvailable['/account/pots']}
          key={`AccountListComponent_AccountComponent_${index}`}
          data={account}
          index={index}
          onClick={accountClick}
          content={content}
        />
      ))}
    </div>
  );
}

AccountListComponent.propTypes = {
  content: PropTypes.object,
  accountClick: PropTypes.func,
  accountList: PropTypes.array,
  savingPot: PropTypes.bool,
};

export { AccountListComponent };
